class Client {
	//默认构造方法
	constructor() {
		this.ua = navigator.userAgent;
	}
	isIos(){
		return this.ua.match(/(iPhone\sOS)\s([\d_]+)/) || this.ua.match(/(iPad).*OS\s([\d_]+)/);
	}
	isAndroid(){
		return this.ua.match(/(Android)\s([\d_]+)/);
	}
	isClient(){
		return this.isAndroid()||this.isIos();
	}
	isApp(){
		return this.ua.match(/(SMGFSQ)/) || (this.isClient() && !this.isWx() && !this.isH5());
	}
	isWx(){
		return this.ua.match(/(MicroMessenger)/);
	}
	isH5(){
		return this.ua.match(/(Safari)/);
	}
}

export default Client;


// WEBPACK FOOTER //
// ./src/utils/Client.js